"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const util_1 = __importDefault(require("util"));
const nearley_1 = require("nearley");
const n_lang_grammar_1 = __importDefault(require("./n-lang.grammar"));
const assert_1 = __importDefault(require("assert"));
function parse(script, { ambiguityOutput = 'omit' } = {}) {
    const parser = new nearley_1.Parser(nearley_1.Grammar.fromCompiled(n_lang_grammar_1.default));
    parser.feed(script);
    const [result, ...ambiguities] = parser.results;
    if (!result) {
        throw new SyntaxError('Unexpected end of input.');
    }
    if (ambiguities.length) {
        try {
            assert_1.default.deepStrictEqual(ambiguities[0], ambiguities[1]);
            console.warn('The first two results are exactly the same! D:');
        }
        catch (err) {
            console.log('Differences between the first two results:', err.message);
        }
        let results;
        switch (ambiguityOutput) {
            case 'omit': {
                results = '[results omitted]';
                break;
            }
            case 'object': {
                results = util_1.default.inspect(parser.results, false, null, true);
                break;
            }
            case 'string': {
                results = parser.results.map(a => a.toString()).join('\n\n');
                break;
            }
        }
        throw new SyntaxError(`You've discovered an ambiguity in the grammar! ${results} (${parser.results.length} items)`);
    }
    return result;
}
exports.parse = parse;
